.icon_TableCell_02c07fa{position:absolute;top:17px;right:19px;pointer-events:none;transform:scale(1.2);color:var(--peachy-purple)}